import { TeacherContract } from '../../contracts/teacher.contract';
import { TeacherGroup } from '../../enums';
import { Kindergarten, User } from '..';
import { DismissedPopupKeywords } from './dismissed_popup_keywords';

export class Teacher {
  constructor(
    public id: number,
    public active: boolean,
    public groups: Array<string> = [],
    public kindergartenIds: Array<number> = [],
    public kindergartens: Array<Kindergarten> = [],
    public hasVisitedManagementApp: boolean,
    public hasHistoryEnabled = true,
    public dismissedPopupKeywords: Array<DismissedPopupKeywords> = []
  ) {}

  /**
   * Deserialize JSON to typescript object.
   *
   * @param data
   * @param user
   */
  public static deserialize(data: TeacherContract, user: User): Teacher {
    let kindergartenIds: number[] = [];
    let kindergartens: Kindergarten[] = [];
    let dismissedPopupKeywords: DismissedPopupKeywords[] = [];
    if (data.kindergarten_ids) kindergartenIds = data.kindergarten_ids;
    if (data.kindergartens) kindergartens = data.kindergartens.map((kindergarten) => Kindergarten.deserialize(kindergarten));
    if (data.dismissed_popup_keywords) dismissedPopupKeywords = data.dismissed_popup_keywords;

    const teacher = new Teacher(
      data.id,
      data.is_active,
      data.groups,
      kindergartenIds,
      kindergartens,
      data.has_visited_management_app,
      data.has_history_enabled !== false,
      dismissedPopupKeywords
    );
    user.teacher = teacher;
    return teacher;
  }

  /**
   * Return teacher object serialized to basic javascript types.
   */
  public serialize(): TeacherContract {
    return {
      id: this.id,
      is_active: this.active,
      groups: this.groups,
      kindergarten_ids: this.kindergartenIds,
      kindergartens: this.kindergartens.map((kindergarten) => kindergarten.serialize()),
      has_visited_management_app: this.hasVisitedManagementApp,
      has_history_enabled: this.hasHistoryEnabled,
      dismissed_popup_keywords: this.dismissedPopupKeywords,
    };
  }

  /**
   * Check if teacher is in a group.
   *
   * @param groupName
   */
  public inGroup(groupName: string): boolean {
    return this.groups.indexOf(groupName) >= 0;
  }

  /**
   * Check if teacher is manager.
   */
  public isManager(): boolean {
    return this.inGroup(TeacherGroup.MANAGER);
  }

  /**
   * CHeck if teacher is director.
   */
  public isDirector(): boolean {
    return this.inGroup(TeacherGroup.DIRECTOR);
  }

  /**
   * Check if teacher belongs to a kindergarten.
   *
   * @param kindergartenId
   */
  public isFromKindergarten(kindergartenId: number): boolean {
    return this.kindergartenIds.indexOf(kindergartenId) >= 0;
  }

  /**
   * It updates teacher data with data of other teacher.
   *
   * @param other
   */
  public replaceData(other: Teacher) {
    this.id = other.id;
    this.active = other.active;
    this.groups = [...other.groups];
    this.kindergartenIds = [...other.kindergartenIds];
    this.kindergartens = [...other.kindergartens];
    this.hasVisitedManagementApp = other.hasVisitedManagementApp;
    this.hasHistoryEnabled = other.hasHistoryEnabled;
    this.dismissedPopupKeywords = [...other.dismissedPopupKeywords];
  }
}
